<template>
  <v-container class="pt-0">
    <v-row justify="center">
      <v-dialog
        v-model="open"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Datos de la materia</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                color="warning"
                @click.stop="deleteDlg = true"
                v-if="!noEliminar"
              >
                <v-icon class="mr-2">mdi-delete-forever</v-icon> Eliminar
              </v-btn>

              <v-btn dark text @click="saveDialog">
                <v-icon class="mr-2">mdi-content-save-edit</v-icon> Guardar
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="7">
                  <v-text-field
                    label="Nombre de la materia"
                    required
                    v-model="materia.nombre"
                  />
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    label="Nombre de la academia"
                    required
                    v-model="materia.academia"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field label="Horas" v-model="materia.horas" />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="materia.semestre"
                    :items="[
                      { text: 'PRIMERO', value: '1' },
                      { text: 'SEGUNDO', value: '2' },
                      { text: 'TERCERO', value: '3' },
                      { text: 'CUARTO', value: '4' },
                      { text: 'QUINTO', value: '5' },
                      { text: 'SEXTO', value: '6' },
                    ]"
                    label="Semestre"
                    required
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field label="Orden" v-model="materia.orden" />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="deleteDlg" persistent max-width="500">
        <v-card>
          <v-card-title class="headline"> Confirma Eliminación </v-card-title>
          <v-card-text
            >Por favor confirma que deseas eliminar el registro de esta materia
            del Tronco Común.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteDlg = false"> Cancelar </v-btn>
            <v-btn color="red darken-1" text @click="deleteDialog">
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Materia",

  props: {
    open: Boolean,
    materia: Object,
    noEliminar: Boolean,
  },

  data: () => ({
    dialog: false,
    deleteDlg: false,
  }),

  methods: {
    closeDialog() {
      this.$emit("exit");
    },

    deleteDialog() {
      this.deleteDlg = false;
      this.$emit("delete");
    },

    saveDialog() {
      this.$emit("save");
    },
  },

  mounted() {},
};
</script>
